import * as React from "react";
import { forwardRef } from "react";
const SvgIcStop32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-stop-32" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M16.0001 13.8788L7.99998 5.87871L5.87866 8.00003L13.8787 16.0001L5.87882 24L8.00014 26.1213L16.0001 18.1214L24 26.1213L26.1213 24L18.1214 16.0001L26.1215 8.00003L24.0001 5.87871L16.0001 13.8788Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcStop32);
export { ForwardRef as ReactComponent };
